module.exports = __webpack_public_path__ + "static/media/OS3.d5975047.jpg";